import React from 'react';
import {Button, ClientTable, Icon, TableColumn} from '@mc/ui-v4';
import {mcDelete} from '@mc/react-ui-icons';

interface LayerFileTableProps {
    files: any[];
    handleDelete: (e: React.MouseEvent<HTMLElement, MouseEvent>, id: string) => void;
}

export const LayerFileTable: React.FC<LayerFileTableProps> = ({files, handleDelete}) => {
    const columns: TableColumn<any>[] = [
        {
            header: 'Název',
            accessor: 'name',
            width: 182,
        },
        {
            header: 'Soubor',
            accessor: 'sourceFileName',
            width: 224,
        },
        {
            id: 'button',
            width: 30,
            className: 'p-0',
            cell: ({row}) => <Button style={'link'} icon={<Icon icon={mcDelete} />} className={'thumbDelete'} onClick={e => handleDelete(e, row.id)} />,
        },
    ];

    return <ClientTable columns={columns} rows={files} />;
};
